import { DateTime } from "luxon"

/*
 * Takes an ISO date string (ex: '2024-06-25' or '2024-06-25T17:36') and converts it to a presentable date (ex: "June 25, 2024")
 */
export const formatISOIntoReadableDate = (isoString: string): string => {
    return DateTime.fromISO(isoString).toFormat("MMMM dd, yyyy")
}
